import {useEffect, useRef, useState, useContext} from 'react';
import {VEDIO_PLAYER_URL} from '../../../services/urls';
import useGaEventTracking from '../../../hooks/UseGaEventTracking';
import { analytics_category, analytics_event, analytics_label} from '../../../assets/constants/staticContentConstants';
import { AppContext } from '../../../context/AppProvider';
// import { AppcuesConstant } from '../../../assets/constants/constants';
// import { putAppCuesData } from '../../../lib/appcues';

type CoursePlayerProps = {
  courseList?: any | null;
  cid?: string;
  fullScreen?: boolean;
  goBackUrl?: string;
  courseUpdate?: any;
  playVideo: any;
  updateCompaletedStatus?: () => void;
  mid?: string;
  updateCompletedCourse?: any;
  courseName?:any
  program_id?:any
  courseType?:any

};
function  CoursePlayer(Props: CoursePlayerProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const {cid} = Props;
  const token = localStorage.getItem('access_token');
  const [pcid] = useState(Props.cid);
  const {state} = useContext(AppContext);
  const gaEventTracker = useGaEventTracking()
  useEffect(() => {
    let url = `${VEDIO_PLAYER_URL}${cid}&access_token=${token}`;
    if (Props.mid) {
      url = url + `&module_id=${Props.mid}`;
    }
    if (url && iframeRef?.current) {
      iframeRef.current.src = url;
      iframeRef.current.setAttribute('allowTransparency', 'true');
      iframeRef.current.setAttribute('allowFullScreen', 'true');
    }
    const closePlayer = (event: any) => {
      if (event.data === 'status:close') {
        Props.playVideo(false);
        window.removeEventListener('message', closePlayer);
      }
      let duration;
      if(event.data?.data?.durationInMilliSecs){
        duration=event.data?.data?.durationInMilliSecs
      } else{
        duration= null
      }
      if (event.data?.statement?.result?.progress === 100){        
        const today = new Date()
        const items = {
          value: null,
          currency: null,
          transaction_id: null,
          items: [{}],
          user_id:state.user?.userId,
          course_name:Props.courseName,
          course_duration:duration,
          completion_date:today.toLocaleDateString(),
          course_id:cid
      }
        gaEventTracker(analytics_event.courseCompleted,analytics_category.buttonClickCourseActivity,analytics_label.CourseFinishedLable,items);
        // const userId=state.user?.email||"";
        // putAppCuesData({
        // event_Name:`${appcues_event.lessonCompleted}_${cid}_${Props.courseName}`,
        // eventName:appcues_event.lessonCompleted,
        // userId: userId,
        // lesson_id: cid,
        // lesson_name: Props.courseName,
        // program_id:Props.program_id,
        // lesson_type:Props?.courseType !== null ? Props?.courseType: AppcuesConstant.otherContent,
        // event_timestamp: new Date().toISOString(),
        // lesson_duration:duration, })

        Props.updateCompaletedStatus && Props?.updateCompaletedStatus();
      }
    };
    window.addEventListener('message', closePlayer);
    return () => {
      window.removeEventListener('message', closePlayer);
    };
  }, [cid]);

  return (
    <div key={`course-player-${Props.cid}`}>
      {pcid && (
        <iframe
          ref={iframeRef}
          id="pplayer_iframe"
          name="pfplayer_frame"
          title="Player"
          width={'100%'}
          height={540}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      )}
    </div>
  );
}

export default CoursePlayer;
